// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"6ef34317","734":"8d9f261c"}[chunkId] + ".chunk.css";
};